/** URL state of /meta-ads-login: a reconnect target, or what Facebook sent back. */
import { defineSearch, param, type RawSearch } from '@/router/search';
import type { MetaSearch } from './meta';

export const parseMetaSearch = (raw: RawSearch): MetaSearch => ({
  connection_id: param.string(raw, 'connection_id'),
  code: param.string(raw, 'code'),
  state: param.string(raw, 'state'),
  error: param.string(raw, 'error'),
  error_description: param.string(raw, 'error_description'),
});

export const metaSearch = defineSearch(parseMetaSearch);
